import { useOperationalAlertsSync } from "@/modules/alerts/presentation/hooks/useOperationalAlertsSync";

/** Mount ภายใน NotificationProvider — sync alerts จาก API */
export function OperationalAlertsSync() {
  useOperationalAlertsSync();
  return null;
}
